'use client';

import { legacySizes } from '~/constants/common/resizeBreakpoints';
import useResizeListener from '~/hooks/common/ui/useResizeListener';

export default function ShareData() {
  useResizeListener(legacySizes);

  return null;
}
